import { OnDestroy, OnInit, } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FoldersService } from '@services';
import { BehaviorSubject, merge, Subject, } from 'rxjs';
import { finalize, takeUntil, tap, } from 'rxjs/operators';
var ENTITIES_PER_REQUEST = 10;
var INITIAL_BATCH_SIZE = 30;
var UserPermissionsComponent = /** @class */ (function () {
    function UserPermissionsComponent(_folders, _translate) {
        var _this = this;
        this._folders = _folders;
        this._translate = _translate;
        this.data$ = new BehaviorSubject([]);
        this.loadingData$ = new BehaviorSubject(true);
        this._hasMoreData = false;
        this._folderRoles = [];
        this._destroyed$ = new Subject();
        this._usernameChange$ = new Subject();
        this.formatRoleSources = function (sources) {
            var groups = sources.reduce(function (acc, curr) {
                if (curr.isInherited) {
                    acc.inherited.push(curr.username);
                }
                else {
                    acc.explicit.push(curr.username);
                }
                return acc;
            }, {
                explicit: [],
                inherited: [],
            });
            var formattedSources = [];
            if (groups.explicit.length) {
                formattedSources.push(_this._translate.instant('check_perms_modal_explicit'));
            }
            if (groups.inherited.length) {
                formattedSources.push(_this._translate.instant('check_perms_modal_inherited_ad_groups', {
                    groups: groups.inherited.join(', '),
                }));
            }
            return formattedSources.join(', ');
        };
        this._loadInitialBatch = function () {
            _this.loadingData$.next(true);
            _this._folders.getAllRolesForUser({
                username: _this._username,
                skip: 0,
                take: INITIAL_BATCH_SIZE,
            }).pipe(finalize(function () { return _this.loadingData$.next(false); }), tap(function (roles) {
                _this._hasMoreData = roles.count > INITIAL_BATCH_SIZE;
                _this.data$.next((!!roles.tenantRoles.length ? [roles.tenantRoles] : []).concat(roles.folderRoles));
                _this._folderRoles = roles.folderRoles;
            }), takeUntil(merge(_this._destroyed$, _this._usernameChange$))).subscribe();
        };
        this._loadMoreData = function () {
            if (!_this._hasMoreData ||
                _this.loadingData$.value) {
                return;
            }
            _this.loadingData$.next(true);
            _this._folders.getAllRolesForUser({
                username: _this._username,
                skip: _this._folderRoles.length,
                take: ENTITIES_PER_REQUEST,
            }).pipe(finalize(function () { return _this.loadingData$.next(false); }), takeUntil(merge(_this._destroyed$, _this._usernameChange$))).subscribe(function (roles) {
                _this._folderRoles = _this._folderRoles.concat(roles.folderRoles);
                _this._hasMoreData = roles.count > _this._folderRoles.length;
                _this.data$.next(_this.data$.value.concat(roles.folderRoles));
            });
        };
    }
    Object.defineProperty(UserPermissionsComponent.prototype, "username", {
        set: function (value) {
            this._username = value;
            this._usernameChange$.next();
            this._loadInitialBatch();
        },
        enumerable: true,
        configurable: true
    });
    UserPermissionsComponent.prototype.ngOnInit = function () {
        this.scrollBottom
            .pipe(takeUntil(this._destroyed$)).subscribe(this._loadMoreData);
    };
    UserPermissionsComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    return UserPermissionsComponent;
}());
export { UserPermissionsComponent };
